import React from 'react';

import { Button, TextField, Tooltip } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import commonStyles from '../../common/common.module.css';
import driverStyle from './driverQueue.module.css';

import fdLogo from '../../../assets/fd_text_logo.png';

const styles = (theme: Theme) =>

  createStyles({
    overrideBorder: {
      border: '1px solid var(--primaryblue)'
    }
  });

  const orderNoTooltip = `
  The freight forwarder or the trucking company that made the appointment, should provide you with an order number. \n If you have this order number, please enter it and click submit.
  `;


interface OrderNumberPageProps {
  classes: any;
  ghaName: string;
  changeScreen: Function;
  changeOrderNumber: (event: any) => void;
  orderNumber: string;
  submit: () => void;
};

const orderNumberPage = (props: OrderNumberPageProps) => {

 const { classes } = props;

 return (
    <div className={ driverStyle.pageWrapper }>
      <div className={ driverStyle.logoWrapper }> 
        <img alt="frontline dynamics logo" src={ fdLogo } className={ driverStyle.logoImg } />
        <div className={ driverStyle.ghaName }>{ props.ghaName } </div>
      </div>

      <div className={ driverStyle.content }>
        <div className={` ${ commonStyles.inputLabelWrapper } ${ commonStyles.mb4 } `}>
          <div className={ commonStyles.fSpaceBtw }>
            <label className={ driverStyle.inputLabel }> Enter your order number </label>
            <Tooltip arrow title={orderNoTooltip} placement="top" style={{ whiteSpace: 'pre-line' }}>
              <HelpIcon color='primary' fontSize='inherit' />
            </Tooltip> 
          </div>
          <TextField
            label=""
            variant="outlined"
            InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
            value={ props.orderNumber }
            onChange={ props.changeOrderNumber }
          />
        </div>
        <Button 
          color="primary" 
          variant="contained"
          className={` ${ driverStyle.button } ${ commonStyles.w100 } `}
          onClick={ () => props.submit() }
        > 
          Submit
        </Button>
      </div>
      <div className={ driverStyle.footer }>
          <Button 
            color="secondary" 
            variant="contained"
            className={` ${ driverStyle.button } ${ driverStyle.redButton } ${ commonStyles.w100 } `}
            onClick={ () => props.changeScreen('home') }
          > 
          I dont have an order number, go back!
        </Button>
      </div> 
        
    </div>
  );
}

export default withStyles(styles)(orderNumberPage);